import React, { useState } from "react";
import { BulkFileUpload } from "./bulk-fileupload";
import BatchList from "./batchList";
import { Container } from "react-bootstrap";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const BulkFileUploadContainer = () => {
    const [selectedBatchId, setSelectedBatchId] = useState(null);
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <Container>
                <BulkFileUpload setSelectedBatchId={setSelectedBatchId} />
                {selectedBatchId && <BatchList batchId={selectedBatchId} />}
            </Container>
        </QueryClientProvider>

    );
}
